import { readStoredJSON } from '../utils/pendingOrder';
import { actionTextColor, lightTint } from "../utils/themeContrast";
import React, { useEffect } from "react";
import { ThemeContext, ActionContext, LanguageContext, UserContext } from "../contexts/Context";
import styled from "@emotion/styled";
import { Link } from "@reach/router";
import { IoCloseOutline } from "react-icons/io5";

const Fail = () => {
  const themeContext = React.useContext(ThemeContext);
  const languageContext = React.useContext(LanguageContext);
  const { lanIndex } = React.useContext(UserContext);
  const { addToCart } = React.useContext(ActionContext);

  useEffect(() => {
    let order = readStoredJSON("order");
    if (Array.isArray(order)) {
      addToCart(order);
    }
  }, [addToCart]);

  if (typeof lanIndex === 'undefined') {
    return <></>
  }
  return (
    <BackgroundColor themeContext={themeContext}>
      <Circle aria-hidden="true">
        <IoCloseOutline size={28} />
      </Circle>

      <Header>{languageContext[lanIndex].paymentFail}</Header>
      <Paragraph>{languageContext[lanIndex].paymentFailDesc}<br />
        {languageContext[lanIndex].tryAgain}
      </Paragraph>

      <OkButtonContainer themeContext={themeContext}>
        <OkButton to="/checkout" themeContext={themeContext}>
          {languageContext[lanIndex].returnCK}
        </OkButton>
      </OkButtonContainer>

    </BackgroundColor>
  );


}

export default Fail;

const Header = styled.h1`
    color: #d50000;
    font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
    font-weight: 900;
    font-size: 20px;
    margin: 12px 16px 0;
    text-align: center;
`;

const Paragraph = styled.p`
    padding-inline: 28px;
    box-sizing: border-box;
    line-height: 1.6;
    color: #404F5E;
    font-family: "Nunito Sans", "Helvetica Neue", sans-serif;
    font-size:15px;
    margin: 20px 0 24px;
    text-align: center;
`;

const Circle = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    height: 48px;
    width: 48px;
    color: #d50000;
    background: #fff2f2;
    margin: 20px auto 0;
`;

const BackgroundColor = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  width: 100vw; max-width: 550px; margin: 0 auto;
  box-sizing: border-box; overflow-y: auto;
  background: ${p => p.themeContext.backgroundColor};
  > * { flex-shrink: 0; }
`;

const OkButtonContainer = styled.div`
  position: sticky; bottom: 0; z-index: 5; box-sizing: border-box; width: 100%;
  margin-top: auto;
  padding: 12px 16px max(12px, env(safe-area-inset-bottom));
  background: ${p => p.themeContext.backgroundColor};
  border-top: 1px solid ${p => lightTint(p.themeContext.primaryColor, .18)};
`;

const OkButton = styled(Link)`
  display: flex; align-items: center; justify-content: center;
  box-sizing: border-box; width: 100%; min-height: 48px; padding: 12px 20px;
  border: 0; border-radius: 999px; text-align: center; text-decoration: none;
  color: ${p => actionTextColor(p.themeContext)};
  background: ${p => p.themeContext.primaryColor};
  font-family: ${p => p.themeContext.fontFamily}; font-size: 14px; font-weight: 600;
  &:focus-visible { outline: 2px solid ${p => p.themeContext.primaryColor}; outline-offset: 3px; }
`;
